import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React, {Suspense, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import './main.less';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom"
// HashRouter BrowserRouter

import {Button, ConfigProvider} from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import {Provider} from 'react-redux'
import store from "./utils/store";

import NProgress from "./components/nprogress";
import common from "./utils/common";
import {Helmet} from "react-helmet";

// import Interactive from "./pages/interactive";
// import Answer from "./pages/answer";
// import Ide from "./pages/ide";
// import App from './App';
// import Screen from "./pages/screen"
// import Share from "./pages/share";
// import Exam from "./pages/exam";
// import ExamDetail from "./pages/exam/detail";
// import PPT from "./pages/ppt";
// import Demo from "./pages/demo";
// import Share2 from "./pages/share/index2";

// const Lesson = React.lazy(() => import("./pages/lesson"));
// const Run = React.lazy(() => import("./pages/lesson/run"));
// const LessonV2 = React.lazy(() => import("./pages/lesson/v2"));
// const Ide = React.lazy(() => import("./pages/ide"));
// const Answer = React.lazy(() => import("./pages/answer"));
const App = React.lazy(() => import("./App"));
const Screen = React.lazy(() => import("./pages/screen"));
const Share = React.lazy(() => import("./pages/share"));
const Exam = React.lazy(() => import("./pages/exam"));
const ExamDetail = React.lazy(() => import("./pages/exam/detail"));
const PPT = React.lazy(() => import("./pages/ppt"));
const Demo = React.lazy(() => import("./pages/demo"));
const LoginResult = React.lazy(() => import("./pages/loginResult"));
const H5Card = React.lazy(() => import("./pages/h5/card"));
const Type = React.lazy(() => import("./pages/type"));
const Player = React.lazy(() => import("./pages/player"));
const Attendance = React.lazy(() => import("./pages/attendance"));
const LearnPath = React.lazy(() => import("./pages/learningPath"));
const LearnPathRoot = React.lazy(() => import("./pages/learningPath/root")); // 根人才计划
const Home = React.lazy(() => import("./pages/home"));
const Discover = React.lazy(() => import("./pages/discover"));

const LessonV2 = (props) => {
    let sectionId = props.match.params.sectionId                     //  当前节id
    window.location.href = "/playground/#/lesson/" + sectionId
    return (<>
        <Button type={'link'} onClick={() => {
            window.history.go(-1)
        }}>返回</Button>
    </>)
}

const RunCode = (props) => {
    let lang = props.match.params.lang
    window.location.href = "/playground/#/run/" + lang
    return (<></>)
}

function Wrap(props) {

    const removeSsr = () => {
        // 删除 SSR 部份
        if (window.document.getElementById('root').innerHTML.trim().length !== 0) {

            // React渲染完成后，50ms，是为了等ajax取数据
            //setTimeout(() => {
            window.document.getElementById('ssr').remove()
            window.document.getElementById('ssrMask').remove()
            // }, 50)

            return
        }
        setTimeout(removeSsr, 50)
    }

    useEffect(() => {
        removeSsr()
    }, [])
    return <>{props.children}</>
}

function Main() {

    const [load, setLoad] = useState(true)
    const [tenant, setTenant] = useState({})

    useEffect(() => {
        setLoad(true)
        common.loadingStart()
        common.ajax('get', '/api/tenant/info', {
            domain: window.location.hostname
            // domain: 'www.daimaku.net'
            // domain: 'ydm.daimaku.net'
            // domain: 'ke.itxb.net'
        }, {
            useToken: false,
        }).then((res) => {
            //console.log(res)
            setTenant(res)
            store.dispatch({type: 'CHANGE_TENANT', tenant: res})

        }).finally(() => {
            setLoad(false)
            common.loadingStop()
        })

    }, [window.location.hostname])


    // 获取未读消息数量  后端依赖这个api统计用户在线时长
    const fetchMessage = () => {
        common.ajax("get", "/api/message/unread", {}, {
            interceptInvalidToken: false,
            displayError: false,
            timeout: 5000,
        }).then(res => {
            store.dispatch({type: 'CHANGE_UNREAD', payload: res.unread_num})
        })
    }

    useEffect(() => {
        fetchMessage()

        let timer = setInterval(() => {
            fetchMessage()
        }, 60 * 2 * 1000)

        return () => {
            clearInterval(timer)
        }
    }, [])


    return <ConfigProvider locale={zhCN}>
        <Provider store={store}>
            {load ? "" :
                <Wrap>
                    {tenant.name ?
                        <Helmet>
                            <title>{tenant.name}</title>
                        </Helmet> : ''}
                    <Router>
                        <Suspense fallback={<NProgress></NProgress>}>
                            <Switch>
                                <Route path={'/attendance/:id'} component={Attendance}/>
                                <Route path={'/exam/:id'} component={Exam}/>
                                <Route path={'/examDetail/:id'} component={ExamDetail}/>
                                <Route exact path={'/run/:lang'} component={RunCode}></Route>
                                {/*<Route exact path={'/lesson/:sectionId'} component={Lesson}></Route>*/}
                                <Route exact path={'/lesson/:sectionId'} component={LessonV2}></Route>
                                {/*<Route exact path={'/lesson/:sectionId'} component={LessonV2}></Route>*/}
                                {/*<Route exact path={'/ide'} component={Ide}></Route>*/}
                                {/*<Route exact path={'/answer'} component={Answer}></Route>*/}
                                <Route exact path={'/screen'} component={Screen}></Route>
                                <Route exact path={'/share-v1'} component={Share}></Route>
                                {/*<Route exact path={'/share'} component={Share2}></Route>*/}
                                <Route exact path={'/ppt'} component={PPT}></Route>
                                <Route exact path={'/type'} component={Type}></Route>
                                <Route exact path={'/demo'} component={Demo}></Route>
                                <Route exact path={'/h5/card'} component={H5Card}></Route>
                                <Route exact path={'/loginResult/:result'} component={LoginResult}></Route>
                                <Route exact path={'/player'} component={Player}></Route>
                                <Route exact path={'/learning-path'} component={LearnPath}></Route>
                                <Route exact path={'/learning-path-root'} component={LearnPathRoot}></Route>
                                <Route exact path={'/discover'} component={Discover}></Route>
                                <Route exact path={'/'} component={Home}></Route>
                                <Route path={'/'} component={App}></Route>
                                <Route path="*">
                                    <div>404 Not Found</div>
                                </Route>
                            </Switch>
                        </Suspense>
                    </Router>
                </Wrap>}
        </Provider>
    </ConfigProvider>
}

export default Main
